export default __webpack_public_path__ + "static/footerBackground-1f6ca7f53ca72be406cbed1eabae8363.png";